import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Modal,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from '@mui/icons-material/Cancel';

const ItemPicker = ({
  component = "TextField", // Accepts "input" or "Button". Default is TextField. Change depending on the usecase. For form inputs, TextField is preferred.
  variant = "outlined", // MUI TextField or Button variant
  size = "medium", // MUI TextField or Button size
  icon = <SearchIcon />, // Icon to show in the clickable component (Only applicable for Button component)
  label, name, ListView, filters, columns, onChange,
  listViewProps = {}, // Additional props to pass to the ListView component
  addButton = false,
  fullWidth = true, initialValue = { name: "", id: "" }, disabled
}) => {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({ name: initialValue.name || "", id: initialValue.id || "" });

  // Dynamically update selectedItem if initialValue changes
  useEffect(() => {
    if (initialValue && initialValue.id && initialValue.name) {
      setSelectedItem({ name: initialValue.name, id: initialValue.id });
    }
  }, [initialValue]);

  const handleSelect = (item) => {
    // onChange({ target: { name, value: item.id, item } }); 
    console.debug('Item selected: ', item);
    setSelectedItem(item);
    if (onChange)
      onChange({ target: { name, value: item.id, item } }); // invoke the onChange with standard event.target format to comply with other inputs
    setOpen(false);
  };

  const handleCancel = () => {
    setSelectedItem({ name: "", id: "" });
    if (onChange)
      onChange({ target: { name, value: "", item: null } });
  };

  const handleClick = (e) => {
    if (!disabled) {
      setOpen(true);
    }
  };



  let clickableComponent = null;

  if (component === "TextField") {
    clickableComponent = (
      <TextField
        label={label}
        name={name}
        value={selectedItem.name || selectedItem.id || ""}
        // onClick={handleClick}
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={handleClick}
                aria-label="select item"
                disabled={disabled}
              >
                {selectedItem.name || selectedItem.id ? <EditIcon /> : <AddIcon />}
              </IconButton>

              {(selectedItem.name || selectedItem.id) && (
                <IconButton
                  edge="end"
                  onClick={handleCancel}
                  aria-label="select item"
                  disabled={disabled}
                  sx={{ ml: 1 }}
                >
                  <CancelIcon />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        disabled={disabled}
      />
    );
  }

  else if (component === "Button") {
    clickableComponent = (
      <Button
        variant={variant}
        size={size}
        startIcon={icon}
        onClick={handleClick}
        disabled={disabled}
      >
        {label}
      </Button>
    );
  }

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto', }}>

      {clickableComponent}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            width: "80%",
            maxWidth: '800px',
            maxHeight: "90vh", // limit modal height
            overflowY: "auto",  // enable scroll if content exceeds max height
          }}
        >
          <ListView
            addButton={addButton}
            filters={filters}
            columns={columns}
            onSelect={handleSelect}
            {...listViewProps}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default ItemPicker;
